import { ENVIRONMENT, appEnvironment } from "../utils/environment"

export const getCubeApiUrl = () => {
  switch (appEnvironment) {
    case ENVIRONMENT.PROD:
      return 'https://yardstick-api.prod.getty.do.artpro.co/api/v1';
    case ENVIRONMENT.STAGING:
      return 'https://yardstick-api.getty.staging.do.artpro.co/api/v1';
    case ENVIRONMENT.DEV:
    case ENVIRONMENT.LOCAL:
    default:
      return 'https://yardstick-api.getty.staging.do.artpro.co/api/v1'
  }
} 